import {
    Container,
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    UncontrolledPopover,
    PopoverHeader,
    PopoverBody,
    Spinner
} from "reactstrap";
import { useEffect, useState } from "react";
import SimpleHeader from "../../components/SimpleHeader/SimpleHeader";
import { updateDevice, createDevice, getFullSubOrganizations, getDevices, getSubscription, getSubscriptionManageLink, getDevicePrinters } from "../../utilities/orgPanelApiCalls";
import { ToastMessage } from '../../components/ToastMessage/ToastMessage.js'
import { errorToast, successToast, warningToast } from '../../constants/toast';
import React from "react";
import HTTPStatus from "../../components/Enums/HTTPStatus";
import SearchBar from "../../components/SearchBar/SearchBar";
import { RoundedButton, ButtonColor, ButtonCorner } from "../../components/Buttons/RoundedButton";
import ManageDeviceModal from "../../components/Shared/ManageDeviceModal";
import ChangeCountManagerModalViewModel from "../../components/SubscriptionManagment/ChangeCountManagerModalViewModel";
import { useStore } from "../../utilities/appStore";
import { deviceTypes } from '../../constants/deviceTypes';
import SubscriptionDetailsViewModel from '../../components/SubscriptionDetails/SubscriptionDetailsViewModel'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { subscriptionStatuses } from '../../components/Enums/SubscriptionStatus';
import { subscriptionStatus } from "../../constants/subscriptionStatus";
import DeviceDataTable from "../../components/DeviceGrid/DeviceDataTable";
import DeleteDeviceModal from "../../components/Shared/ViewModels/DeleteDeviceModalViewModel";
import Button from "../../components/UIButton/UIButton";
import SearchInput from "../../components/Search/SearchInput";

const DevicesPage = () => {
    const [loader, setLoader] = useState(0);
    const [showManageModal, setShowManageModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [modalIsLoading, setModalIsLoading] = useState(true);
    const [manageData, setManageData] = useState(null);
    const [locationData, setLocationData] = useState(null);
    const [deviceData, setDeviceData] = useState(null);
    const [subscriptionData, setSubscriptionData] = useState(null);
    const [toast, SetToast] = useState();
    const [searchTerm, setSearchTerm] = useState(null);
    const [filteredDevices, setFilteredDevices] = useState([]);
    const [activeDevicesCount, setActiveDevicesCount] = useState(0);
    const [showSubscriptionDetails, setShowSubscriptionDetails] = useState(false);
    const [isDeviceErrored, setIsDeviceErrored] = useState(false);
    const [printerData, setPrinterData] = useState([]);
    const [showPopover, setShowPopover] = useState(true);
    const [modalMode, setModalMode] = useState("edit");
    
    let organization = useStore((state) => state.CurrentOrganization);
    let orgId = useStore((state) => state.CurrentOrganizationId);
    let newLicenseCount = useStore((state) => state.NewLicenseCount);

    useEffect(() => {
        const usedDevices = deviceData?.filter(x => x.subscriptionStatus === subscriptionStatus.Active && x.deviceType === deviceTypes.SubscriptionDevice)?.length;
        setActiveDevicesCount(usedDevices);
    }, [deviceData])


    useEffect(() => {
        async function load() {
            setIsLoading(true);

            const [subOrgResponse, deviceResult, subscriptionResult] = await Promise.all([
                getFullSubOrganizations(orgId),
                getDevices(orgId),
                getSubscription(orgId)
            ]);

            if (subscriptionResult.status === HTTPStatus.NotFound) {
                setSubscriptionData(false);
                //No active subscrition
            }
            else if (subscriptionResult > 299)
                console.log("Failed to load subscription data");
            else
                setSubscriptionData(subscriptionResult.data);

            if (deviceResult > 299) {
                setIsDeviceErrored(true);
                console.log("Failed to load device data");
            }
            else {
                var deviceResultData = [...deviceResult?.data]
                setDeviceData(deviceResultData);
            }

            if (subOrgResponse.status > 299)
                console.log("Failed to load sub orgs!");
            else {
                var subOrgData = [...subOrgResponse.data];


                var locations = [];
                for (var i = 0; i < subOrgData.length; i++) {
                    //Filter to only populate with organization type locations
                    if (subOrgData[i].accountTypeId === 5) {
                        locations.push({
                            label: subOrgData[i].name,
                            value: subOrgData[i].accountID.toString()
                        });
                    }
                }

                setLocationData(locations);
                setIsLoading(false);

            }
        }
        load();

    }, [loader, orgId]);

    useEffect(() => {
        const filterDevices = () => {
            if (searchTerm != null && searchTerm.trim() !== '') {
                var lowerSearchTerm = searchTerm.toLowerCase();
                setFilteredDevices(deviceData?.filter(x =>
                    x.deviceName?.toLowerCase()?.includes(lowerSearchTerm) ||
                    x.description?.toLowerCase()?.includes(lowerSearchTerm) ||
                    x.locationName?.toLowerCase()?.includes(lowerSearchTerm) ||
                    x.serialNumber?.toLowerCase()?.includes(lowerSearchTerm)
                ));
            }
            else {
                setFilteredDevices(deviceData);
            }
        }

        filterDevices();
    }, [searchTerm, deviceData]);

    const toggleDeleteModal = (item) => {
        setManageData(item);
        setShowDeleteModal(!showDeleteModal);
    }

    const refreshDevices = async () => {
        setIsLoading(true)
        var deviceResult = await getDevices(orgId);
        var deviceResultData = [...deviceResult.data]
        setDeviceData(deviceResultData);
        setIsLoading(false);
    }

    const toggleManageModal = async (item, openMode) => {
        setModalMode(openMode);
        if (openMode === "create" && (subscriptionData.seats - activeDevicesCount <= 0)) {
            alert("There are no unused subscription licenses available. To create a new device, delete a different one or add more licenses to your subscription.");
            return;
        }
        setModalIsLoading(true);
        setShowManageModal(true);
        var printerResult = await getDevicePrinters();

        setPrinterData(printerResult?.data);
        setManageData(item);
        setModalIsLoading(false);

    }

    const makeToast = (message, type) => {
        SetToast({
            display: true,
            message: message,
            type: type
        });
    }

    const showSubscriptionDetailsPopover = () => {
        setShowSubscriptionDetails(!showSubscriptionDetails);
    }
    const handleCreate = async (model) => {
        setModalIsLoading(true);
        const deviceResponse = await createDevice(model.location, model, subscriptionData.subscriptionId, orgId);
        const responseStatus = deviceResponse?.status;

        if (responseStatus === 403 || responseStatus === 401) {
            setModalIsLoading(false);
            makeToast("Authorization error creating device.", errorToast);
        }
        else if (responseStatus > 299) {
            setModalIsLoading(false);
            makeToast(deviceResponse?.errorMsg ?? "Error creating device.", errorToast);
        }
        else {
            setShowManageModal(false);
            refreshDevices();
            makeToast("Device Created", successToast);
            setModalIsLoading(false);
        }
    }
    const handleUpdate = async (model, event) => {
        model.accountId = event.target.accountId?.value;
        model.uDID = event.target.uDID.value;
        model.serialNumber = event.target.serialNumber.value;
        model.deviceType = parseInt(event.target.deviceType.value);
        setModalIsLoading(true);
        var response = await updateDevice(model.location, model);

        if (response === 403 || response === 401) {
            makeToast("Authorization error updating device: " + response.message, errorToast);
            setModalIsLoading(false);
        }
        else if (response > 299) {
            makeToast("Error updating device: " + response.message, errorToast);
            setModalIsLoading(false);
        }
        else {
            setShowManageModal(false);
            refreshDevices();
            makeToast("Device Updated", successToast);
            setModalIsLoading(false);
        }
    }

    const handleModalSubmit = async (e) => {
        e.preventDefault();
        var model = {
            name: e.target.name.value,
            //seatDetails: e.target.seatDetails.value,
            description: e.target.description.value,
            location: e.target.location.value,
            printerId: e.target.printer.value,
            isActive: true
        }

        var isValid = true;

        if (model.name === "" || model.name === null) {
            makeToast("Device name is a required field.", errorToast);
            isValid = false;
        }

        if (model.location === "" || model.location === null) {
            makeToast("Location is a required field.", errorToast);
            isValid = false;
        }

        if (model.printerId === "" || model.printerId === null) {
            makeToast("Printer is a required field.", errorToast);
            isValid = false;
        }

        
        if (isValid) {
            if (e.target.accountId?.value !== '' && e.target.uDID.value !== '') {
                await handleUpdate(model, e);
            }
            else {
                await handleCreate(model);
            }
        }
    }

    const toastToggleCallback = () => {
        SetToast({
            display: false,
            message: ""
        });
    }
    const reload = () => {
        setLoader(loader + 1);
    }

    const manageSubscription = async (e) => {
        setShowSubscriptionModal(true);
        setShowPopover(false);
    }

    const goToBilling = async (e) => {
        if (subscriptionData !== false) {
            let link = await getSubscriptionManageLink(orgId);

            window.location.href = link.data;

        }
    }

    // Only display the new license count if the number of seats increased
    const displayedSeatCount = (newLicenseCount ? Math.max(newLicenseCount, subscriptionData?.seats ?? 0) : subscriptionData?.seats ?? 0);

    const closeModals = () => {
        setShowManageModal(false);
        setShowSubscriptionModal(false);
        setShowPopover(true);
    };


    return (
        <>
            <SimpleHeader name="Home" parentName="Devices and Licenses" />
            {toast?.display && (
                <ToastMessage Message={toast?.message} ToggleCallback={toastToggleCallback} Type={toast?.type} />

            )}
            <Container className="mt--6" fluid>
                <Row className="justify-content-center">
                    <Col className="card-wrapper">
                        <Card className="card-header-devices">
                            <CardHeader>
                                <Container fluid>
                                    {isLoading &&
                                        <Spinner className="centered-loader" />
                                    }
                                    {!isLoading && isDeviceErrored && <Row className="error-msg-row">There was an issue loading devices for this organization. Please contact support for assistance.</Row>}
                                    {!isLoading && !isDeviceErrored &&
                                        <>
                                            <Row className="align-items-end">
                                                <h2 className="">Devices for {organization?.name} ({organization.accountId})</h2>
                                                {subscriptionData && subscriptionData.status !== subscriptionStatuses.Pending && activeDevicesCount >= 0 &&
                                                    <>
                                                        <h5 className="ml-3 text-success" id="activeSubscriptionCount">{displayedSeatCount - activeDevicesCount}</h5>
                                                        <h5 className="ml-1"> of {displayedSeatCount} LICENSES AVAILABLE</h5>
                                                        {subscriptionData.status == subscriptionStatuses.ActivePendingChange &&
                                                            <>
                                                                <a className="ml-1 h5" id="subDetailsPopover" role="button" onClick={showSubscriptionDetailsPopover}> <FontAwesomeIcon icon={faInfoCircle} /></a>
                                                                <SubscriptionDetailsViewModel
                                                                    target="subDetailsPopover"
                                                                    isOpen={showSubscriptionDetails}
                                                                    orgId={orgId}
                                                                    toggle={showSubscriptionDetailsPopover}
                                                                />
                                                            </>
                                                        }
                                                    </>
                                                }
                                            </Row>
                                            <Row className="">
                                                <Col lg={5} className="pl-0">
                                                    <SearchInput className="align-self-end" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                                                </Col>
                                            <Col lg={7} className="pr-0 d-flex justify-content-end">
                                                    <div className="ml-auto">
                                                        <Button variant="primary" className="mgss">MANAGE LICENSES</Button>

                                                        {showPopover && <>
                                                            <UncontrolledPopover
                                                                className="popover-container"
                                                                placement="bottom"
                                                                target=".mgss"
                                                                trigger="focus"
                                                                style={{ width: "500px" }}
                                                            >
                                                                <PopoverHeader className="text-center">
                                                                    What would you like to do?
                                                                </PopoverHeader>
                                                                <PopoverBody>
                                                                    {subscriptionData &&
                                                                        <Container>
                                                                            <Row>
                                                                                <Col sm={5}>
                                                                                    <p>Each license allows you to install and use the app on one device. Click below to add or remove licenses from your account.</p>

                                                                                </Col>
                                                                                <Col sm={2}>
                                                                                    <div className="mx-auto" style={{ height: "100%", width: "1px", border: "1px solid var(--base-color-gray-background)" }} />
                                                                                </Col>
                                                                                <Col sm={5}>
                                                                                    <p>To change payment methods, download invoices, or pay past-due bills, please go to the Stripe billing portal using the button below.</p>

                                                                                </Col>
                                                                            </Row>
                                                                            <Row className="mb-3">
                                                                                <Col sm={5}>
                                                                                    <div className="text-center">
                                                                                        <RoundedButton
                                                                                            className="mr-3 mgss"
                                                                                            hoverColor={ButtonColor.Black}
                                                                                            hoverTextColor={ButtonColor.White}
                                                                                            hoverOutlineColor={ButtonColor.Black}
                                                                                            textColor={ButtonColor.White}
                                                                                            buttonColor={ButtonColor.DarkBlue}
                                                                                            outlineColor={ButtonColor.DarkBlue}
                                                                                            cornerRadius={ButtonCorner.TenPX}
                                                                                            mouseDownHandler={manageSubscription}
                                                                                            width='100%'
                                                                                            text="Change license count" />
                                                                                    </div>
                                                                                </Col>
                                                                                <Col sm={2}>
                                                                                </Col>
                                                                                <Col sm={5}>
                                                                                    <div className="text-center">
                                                                                        <RoundedButton
                                                                                            className="mr-3 mgss"
                                                                                            hoverColor={ButtonColor.Black}
                                                                                            hoverTextColor={ButtonColor.White}
                                                                                            hoverOutlineColor={ButtonColor.Black}
                                                                                            textColor={ButtonColor.White}
                                                                                            buttonColor={ButtonColor.DarkBlue}
                                                                                            outlineColor={ButtonColor.DarkBlue}
                                                                                            cornerRadius={ButtonCorner.TenPX}
                                                                                            mouseDownHandler={goToBilling}
                                                                                            width='100%'
                                                                                            text="Go to billing portal" />
                                                                                    </div>
                                                                                </Col>
                                                                            </Row>
                                                                        </Container>
                                                                    }
                                                                    {!subscriptionData &&
                                                                        <Container>
                                                                            <Col className="text-center">
                                                                                <p>You will need a subscription to use any SaaS-licensed devices. Each license allows you to install and use the app on one SaaS device. Click below to create a new subscription.</p>
                                                                                <RoundedButton
                                                                                    className="mr-3 mgss"
                                                                                    hoverColor={ButtonColor.Grey}
                                                                                    hoverTextColor={ButtonColor.White}
                                                                                    hoverOutlineColor={ButtonColor.Grey}
                                                                                    textColor={ButtonColor.Grey}
                                                                                    buttonColor={ButtonColor.White}
                                                                                    outlineColor={ButtonColor.Grey}
                                                                                    cornerRadius={ButtonCorner.TenPX}
                                                                                    mouseDownHandler={manageSubscription}
                                                                                    text="Create Subscription" />
                                                                            </Col>
                                                                        </Container>
                                                                    }
                                                                </PopoverBody>
                                                            </UncontrolledPopover>
                                                        </>}

                                                        <Button
                                                            variant="primary"
                                                            id="addDeviceBtn"
                                                            onClick={() => toggleManageModal(null, "create")}
                                                        >+ ADD A DEVICE</Button>
                                                    </div>
                                                </Col>  
                                            </Row>
                                        </>
                                    }
                                </Container>
                            </CardHeader>
                            <CardBody>
                                {!isLoading && <DeviceDataTable
                                    toastCallback={makeToast}
                                    data={filteredDevices}
                                    isLoading={isLoading}
                                    setIsLoading={setIsLoading}
                                    onEditClick={(item) => toggleManageModal(item, "edit")}
                                    onDeleteClick={toggleDeleteModal}
                                    refreshDevices={refreshDevices}
                                />}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>

            <ManageDeviceModal
                isLoading={modalIsLoading}
                isOpen={showManageModal}
                submitHandler={handleModalSubmit}
                handleClose={closeModals}
                manageData={manageData}
                locationData={locationData}
                printerData={printerData}
                modalMode={modalMode}
                refreshDevices={refreshDevices}
                toastCallback={makeToast}
            />
            {showDeleteModal &&
                <DeleteDeviceModal
                    deviceData={manageData}
                    pageToggle={toggleDeleteModal}
                    toastCallback={makeToast}
                    completeCallback={refreshDevices}
                    subscriptionId={subscriptionData.subscriptionId}
                />
            }

            <ChangeCountManagerModalViewModel
                isOpen={showSubscriptionModal}
                accountId={orgId}
                handleClose={closeModals}
                handleSuccess={reload}
                isLoading={isLoading}
            />
        </>
    );
};

export default DevicesPage;
